export const mobile = {
  min: 0,
  max: 600,
};

export const desktop = {
  min: 1025,
  max: 1200,
};

export const tablet = {
  min: 601,
  max: 1024,
};



// WEBPACK FOOTER //
// ./src/utils/breakpoints.js